import React from 'react';
import renderHTML from 'react-render-html';

const TestResult = ({ imgSrc1, alt1, title1, subTitle1, imgSrc2, alt2, title2, subTitle2, imgSrc3, alt3, title3, subTitle3 }) => {
	return (
		<section className="row hour-test">
			<div className="callouts">
				<div className="col sm-2">
					<img className="icon" src={ imgSrc1 } alt={ alt1 } />
					<h3 className="sub-title">{ renderHTML(title1) }</h3>
					<p>{ renderHTML(subTitle1) }</p>
				</div>
				<div className="col sm-2">
					<img className="icon" src={ imgSrc2 } alt={ alt2 } />
					<h3 className="sub-title">{ renderHTML(title2) }</h3>
					<p>{ renderHTML(subTitle2) }</p>
				</div>
				<div className="col sm-2">
					<img className="icon" src={ imgSrc3 } alt={ alt3 } />
					<h3 className="sub-title">{ renderHTML(title3) }</h3>
					<p>{ renderHTML(subTitle3) }</p>
				</div>
			</div>
		</section>
	);
};

export default TestResult;


// WEBPACK FOOTER //
// ./src/pages/category/common/TestResult.js